import React from "react";

//Styles
import "./VideoModal.scss";

function VideoModal({ isModalShown, setIsModalShown }) {
  return (
    <div className={"modal-wrapper" + (isModalShown ? " shown" : "")}>
      <button
        className="closing-bg"
        onClick={() => {
          setIsModalShown(false);
        }}
      ></button>

      <div className="video-modal">
        <iframe src="https://www.youtube.com/embed/Mh8YhXVCgZs" allowFullScreen="1" frameBorder="0" title="Presentation video"></iframe>
        <button
          className="closing-button"
          onClick={() => {
            setIsModalShown(false);
          }}
        >
          <span></span>
          <span></span>
        </button>
      </div>
    </div>
  );
}

export default VideoModal;
